import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createLead } from '../../api/leadApi';
import VehicleForm from './VehicleForm';
import { useAuth } from '../../auth/AuthContext';
import './CreateLead.css';

const CreateLead = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const { userProfile } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (formData) => {
        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            // Add user information if available
            const leadData = {
                ...formData,
                lead_type: 'auto',
                name: userProfile?.name || 'Anonymous',
                email: userProfile?.email || 'anonymous@example.com',
                phone: userProfile?.phone || ''
            };

            // Log the vehicle details from the API
            console.log('Vehicle details:', {
                year: formData.year,
                make: formData.make,
                model: formData.model,
                color: formData.color
            });

            const result = await createLead(leadData);
            
            if (result.success) {
                setSuccess(true);
                // Redirect to dashboard or confirmation page after 2 seconds
                setTimeout(() => {
                    navigate('/dashboard');
                }, 2000);
            } else {
                setError('Failed to create lead. Please try again.');
            }
        } catch (err) {
            console.error('Error submitting lead:', err);
            setError('An unexpected error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="create-lead-container">
            <div className="create-lead-header">
                <h1>Tell Us About Your Dream Vehicle</h1>
                <p>Fill out the form below and we'll connect you with verified sellers who have exactly what you're looking for.</p>
            </div>

            {error && (
                <div className="error-message">
                    {error}
                </div>
            )}

            {success ? (
                <div className="success-message">
                    <h2>Lead Created Successfully!</h2>
                    <p>Thank you for submitting your vehicle request. We'll start matching you with sellers right away.</p>
                    <p>Redirecting to your dashboard...</p>
                </div>
            ) : (
                <VehicleForm 
                    onSubmit={handleSubmit} 
                    initialData={{
                        // Pre-fill with user profile data if available
                        name: userProfile?.name || '',
                        email: userProfile?.email || '',
                        phone: userProfile?.phone || ''
                    }}
                />
            )}

            {loading && (
                <div className="loading-overlay">
                    <div className="loading-spinner"></div>
                    <p>Submitting your request...</p>
                </div>
            )}
        </div>
    );
};

export default CreateLead;
